import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rdsFilterOptions'
})
export class RdsFilterOptionsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
